function HeroBlooms() {
  return (
    <>
      <div
        aria-hidden
        className="pointer-events-none absolute -right-10 -top-20 h-[300px] w-[300px] rounded-full [background:var(--chekin-hero-bloom-mint)]"
      />
      <div
        aria-hidden
        className="pointer-events-none absolute -bottom-[100px] right-40 h-60 w-60 rounded-full [background:var(--chekin-hero-bloom-periwinkle)]"
      />
    </>
  );
}

export {HeroBlooms};
